import { ChevronRightIcon } from "@heroicons/react/24/outline";
// nextui
import { Accordion, AccordionItem, Divider } from "@nextui-org/react";
// react imports
import React, { useEffect, useState } from "react";
// react-i18next
import { useTranslation } from "react-i18next";
import { useApi } from "../Context/ApiProvider";

export default function Faq() {
  const { t } = useTranslation();
  const [faqs, setFaqs] = useState([]);
  const api = useApi();

  useEffect(() => {
    (async () => {
      const resFaqs = await api.uget(`/api/faqs?`);
      if (resFaqs.ok && resFaqs.body) {
        setFaqs(resFaqs.body.results);
      }
    })();
  }, [api]);

  return (
    <div
      style={{
        backgroundImage: 'url("/Assets/Images/sss.jpg")',
        backgroundPosition: "center",
      }}
    >
      <div className="flex  flex-col items-center justify-center ">
        <h2 className="font-bold text-4xl  mt-5 text-white ">
          {t("FrequentlyAskedQuestions")}
        </h2>
        <Divider className="bg-red-600 h-1 w-52 md:w-64 mt-2" />
      </div>
      <section className="flex flex-col px-5 md:px-5 gap-4 justify-center items-center xl:w-[85%] m-auto  ">
        <div className="flex flex-col md:flex-row items-center justify-between ">
          <div className=" text-center xl:w-full ">
            <img
              className=" hover:animate-pulse  "
              src="https://i.imgur.com/WbQnbas.png"
              alt="FAQ"
            />
          </div>
          <Accordion>
            {faqs.map(({ id, question, answer }) => (
              <AccordionItem
                key={id}
                indicator={<ChevronRightIcon className="w-3.5 h-3.5" />}
                classNames={{
                  title:
                    "font-semibold text-sm lg:text-lg text-white  md:leading-none whitespace-break-spaces ",
                  content:
                    "text-justify text-sm lg:text-md text-white leading-loose ",
                }}
                title={question}
              >
                <div dangerouslySetInnerHTML={{ __html: answer }} />
              </AccordionItem>
            ))}
          </Accordion>
        </div>
      </section>
    </div>
  );
}
